import { createContext, useContext, useEffect, useState } from "react";
import { STR } from "@/i18n/strings";

const LangContext = createContext({ lang: "bn", toggle: () => {}, t: (k) => STR[k]?.bn ?? k });

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("rls_lang") || "bn");

  const toggle = () =>
    setLang((l) => {
      const n = l === "bn" ? "en" : "bn";
      localStorage.setItem("rls_lang", n);
      return n;
    });

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key, vars) => {
    let s = STR[key]?.[lang] ?? STR[key]?.bn ?? key;
    if (vars) for (const [k, v] of Object.entries(vars)) s = s.replace(`{${k}}`, v);
    return s;
  };

  return <LangContext.Provider value={{ lang, toggle, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
